const Manage = ({ children }) => {
  return <section className="w-100 sdg-admin-manage">{children}</section>;
};

export default Manage;
